import { initialState } from './reducer';
export var selectLoading = function (state) {
    return (state.media || initialState).loading || false;
};
export var selectFiles = function (state) { return (state.media || initialState).files || []; };
export var selectFolders = function (state) {
    return (state.media || initialState).folders || [];
};
export var selectSelectedFolderId = function (state) {
    return (state.media || initialState).selectedFolderId || '';
};
export var selectSetSearchValue = function (state) {
    return (state.media || initialState).searchValue || '';
};
export var selectFileType = function (state) {
    return (state.media || initialState).fileType || '';
};
export var selectFilesWithLoadingError = function (state) {
    return (state.media || initialState).filesWithLoadingError || [];
};
export var selectErrorSavingFile = function (state) {
    return (state.media || initialState).errorSavingFile || false;
};
export var selectMediaDomain = function (state) { return state.media || initialState || {}; };
